import * as React from "react";
const RightArrowMoblie = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={9}
    fill="none"
    {...props}
  >
    <path
      stroke="#4F2E03"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.073}
      d="M9 4.5H1.49M9 4.5 5.782 1.28M9 4.5 5.782 7.718"
    />
  </svg>
);
export default RightArrowMoblie;
